var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 1536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1b1b1b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 700,
    width: 70,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 740,
    width: 70,
    height: 440
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 780,
    width: 70,
    height: 380
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 820,
    width: 70,
    height: 320
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 860,
    width: 70,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 700,
    width: 70,
    height: 440
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 740,
    width: 70,
    height: 380
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 780,
    width: 70,
    height: 320
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 820,
    width: 70,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 860,
    width: 70,
    height: 440
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 700,
    width: 70,
    height: 380
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 740,
    width: 70,
    height: 320
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 780,
    width: 70,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: 820,
    width: 70,
    height: 440
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 860,
    width: 70,
    height: 380
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350,
    y: 700,
    width: 70,
    height: 320
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 740,
    width: 70,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 780,
    width: 70,
    height: 440
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620,
    y: 820,
    width: 70,
    height: 380
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710,
    y: 860,
    width: 70,
    height: 320
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800,
    y: 700,
    width: 70,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1890,
    y: 740,
    width: 70,
    height: 440
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1980,
    y: 780,
    width: 70,
    height: 380
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2070,
    y: 820,
    width: 70,
    height: 320
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2160,
    y: 860,
    width: 70,
    height: 500
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.6778bbac585347789478d0b85bc33af4.svg";
export { ForwardRef as ReactComponent };